import actionTypes from "../actionTypes";

export function setGameInfo(gameInfo: any) {
  return {
    type: actionTypes.SET_GAME_INFO,
    gameInfo
  }
}

export function resetGameInfo() {
  return {
    type: actionTypes.RESET_GAME_INFO
  }
}
